/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosAnalyticsGeneralChartListInfo } from '../models/AptosAnalyticsGeneralChartListInfo';
import type { AptosGeneralAnalyticsRequest } from '../models/AptosGeneralAnalyticsRequest';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';
import type { HumanityAnalyticsBlockCountRequest } from '../models/HumanityAnalyticsBlockCountRequest';
import type { HumanityAnalyticsBlockCreatedTimeRequest } from '../models/HumanityAnalyticsBlockCreatedTimeRequest';
import type { HumanityAnalyticsGeneralChartListInfo } from '../models/HumanityAnalyticsGeneralChartListInfo';
import type { HumanityAnalyticsNetflowChartListInfo } from '../models/HumanityAnalyticsNetflowChartListInfo';
import type { HumanityAnalyticsNewAccountRequest } from '../models/HumanityAnalyticsNewAccountRequest';
import type { HumanityAnalyticsSummaryInfo } from '../models/HumanityAnalyticsSummaryInfo';
import type { HumanityAnalyticsTopVcIssuerListInfo } from '../models/HumanityAnalyticsTopVcIssuerListInfo';
import type { HumanityAnalyticsTopVcIssuerRequest } from '../models/HumanityAnalyticsTopVcIssuerRequest';
import type { HumanityAnalyticsTrxCountRequest } from '../models/HumanityAnalyticsTrxCountRequest';
import type { HumanityAnalyticsTrxFeeRequest } from '../models/HumanityAnalyticsTrxFeeRequest';
import type { HumanityAnalyticsVcIssuanceRequest } from '../models/HumanityAnalyticsVcIssuanceRequest';
import type { HumanityAnalyticsVerifiedCompletedUserRequest } from '../models/HumanityAnalyticsVerifiedCompletedUserRequest';
import type { KiteAnalyticsBlockCountRequest } from '../models/KiteAnalyticsBlockCountRequest';
import type { KiteAnalyticsBlockCreatedTimeRequest } from '../models/KiteAnalyticsBlockCreatedTimeRequest';
import type { KiteAnalyticsGeneralChartListInfo } from '../models/KiteAnalyticsGeneralChartListInfo';
import type { KiteAnalyticsNewAccountRequest } from '../models/KiteAnalyticsNewAccountRequest';
import type { KiteAnalyticsRequest } from '../models/KiteAnalyticsRequest';
import type { KiteAnalyticsSummaryInfo } from '../models/KiteAnalyticsSummaryInfo';
import type { KiteAnalyticsTotalAgentCallRequest } from '../models/KiteAnalyticsTotalAgentCallRequest';
import type { KiteAnalyticsTotalSubnetCallCountRequest } from '../models/KiteAnalyticsTotalSubnetCallCountRequest';
import type { KiteAnalyticsTotalSubnetCountRequest } from '../models/KiteAnalyticsTotalSubnetCountRequest';
import type { KiteAnalyticsTrxFeeRequest } from '../models/KiteAnalyticsTrxFeeRequest';
import type { KiteAnalyticsTrxTpsRequest } from '../models/KiteAnalyticsTrxTpsRequest';
import type { KiteAnalyticsUaaRequest } from '../models/KiteAnalyticsUaaRequest';
import type { KiteAnalyticsUawCalledAgentsRequest } from '../models/KiteAnalyticsUawCalledAgentsRequest';
import type { NexonAnalyticsGeneralChartListInfo } from '../models/NexonAnalyticsGeneralChartListInfo';
import type { NexonAnalyticsHolderRequest } from '../models/NexonAnalyticsHolderRequest';
import type { NexonAnalyticsRequest } from '../models/NexonAnalyticsRequest';
import type { NexonAnalyticsRetentionRateRequest } from '../models/NexonAnalyticsRetentionRateRequest';
import type { NexonAnalyticsTrxCountRequest } from '../models/NexonAnalyticsTrxCountRequest';
import type { NexonAnalyticsUAWRequest } from '../models/NexonAnalyticsUAWRequest';
import type { NexonAnalyticsUserRequest } from '../models/NexonAnalyticsUserRequest';
import type { ZerogAnalyticsGeneralChartListInfo } from '../models/ZerogAnalyticsGeneralChartListInfo';
import type { ZerogAnalyticsGeneralRequest } from '../models/ZerogAnalyticsGeneralRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AnalyticsControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getVerifiedPalmScanUserCount({
        requestBody,
    }: {
        requestBody: HumanityAnalyticsVerifiedCompletedUserRequest,
    }): CancelablePromise<HumanityAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/vc/verified/palm/scan',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTopVcIssuer({
        requestBody,
    }: {
        requestBody: HumanityAnalyticsTopVcIssuerRequest,
    }): CancelablePromise<HumanityAnalyticsTopVcIssuerListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/vc/issuer/top',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getVcIssuance({
        requestBody,
    }: {
        requestBody: HumanityAnalyticsVcIssuanceRequest,
    }): CancelablePromise<HumanityAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/vc/issuance/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getUserTransactions({
        requestBody,
    }: {
        requestBody: KiteAnalyticsRequest,
    }): CancelablePromise<KiteAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/user/transaction',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getMsuTotalUsers({
        requestBody,
    }: {
        requestBody: NexonAnalyticsUserRequest,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/user/total/users',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getUserStickiness({
        requestBody,
    }: {
        requestBody: NexonAnalyticsUserRequest,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/user/stickiness',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getRetentionRate({
        requestBody,
    }: {
        requestBody: NexonAnalyticsRetentionRateRequest,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/user/retention/rate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNewRegisteredUsers({
        requestBody,
    }: {
        requestBody: NexonAnalyticsUserRequest,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/user/new/registered',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getMsuUniqueActiveWallets({
        requestBody,
    }: {
        requestBody: NexonAnalyticsRequest,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/user/msu/uaw',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getMsnUniqueActiveWallet({
        requestBody,
    }: {
        requestBody: NexonAnalyticsUAWRequest,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/user/msn/uaw',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getMsnUniqueActiveAddress({
        requestBody,
    }: {
        requestBody: NexonAnalyticsUAWRequest,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/user/msn/uaa',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getUniqueActiveAddress({
        requestBody,
    }: {
        requestBody: (KiteAnalyticsUaaRequest | ZerogAnalyticsGeneralRequest),
    }): CancelablePromise<(KiteAnalyticsGeneralChartListInfo | ZerogAnalyticsGeneralChartListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/user/account/uaa',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNewAccountCount({
        requestBody,
    }: {
        requestBody: (HumanityAnalyticsNewAccountRequest | KiteAnalyticsNewAccountRequest | ZerogAnalyticsGeneralRequest),
    }): CancelablePromise<(HumanityAnalyticsGeneralChartListInfo | KiteAnalyticsGeneralChartListInfo | ZerogAnalyticsGeneralChartListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/user/account/new/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTvl({
        requestBody,
    }: {
        requestBody: KiteAnalyticsRequest,
    }): CancelablePromise<KiteAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/tvl',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTotalGasUsed({
        requestBody,
    }: {
        requestBody: ZerogAnalyticsGeneralRequest,
    }): CancelablePromise<ZerogAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/transaction/total/gasused',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAverageTrxBaseFee({
        requestBody,
    }: {
        requestBody: ZerogAnalyticsGeneralRequest,
    }): CancelablePromise<ZerogAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/transaction/basefee/average',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTransactionAvgGasPrice({
        requestBody,
    }: {
        requestBody: ZerogAnalyticsGeneralRequest,
    }): CancelablePromise<ZerogAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/transaction/avg/gas/price',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTotalUsers({
        requestBody,
    }: {
        requestBody: KiteAnalyticsRequest,
    }): CancelablePromise<KiteAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/total/users',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNxpcHolder({
        requestBody,
    }: {
        requestBody: NexonAnalyticsHolderRequest,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/token/nxpc/holder',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNftHolder({
        requestBody,
    }: {
        requestBody: NexonAnalyticsHolderRequest,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/token/nft/holder',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNesoHolder({
        requestBody,
    }: {
        requestBody: NexonAnalyticsHolderRequest,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/token/neso/holder',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getSummary({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<(HumanityAnalyticsSummaryInfo | KiteAnalyticsSummaryInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNetworkUtilizationAvg({
        requestBody,
    }: {
        requestBody: HumanityAnalyticsTrxCountRequest,
    }): CancelablePromise<HumanityAnalyticsNetflowChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/network/utilization/avg',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTrxTps({
        requestBody,
    }: {
        requestBody: (KiteAnalyticsTrxTpsRequest | ZerogAnalyticsGeneralRequest),
    }): CancelablePromise<(KiteAnalyticsGeneralChartListInfo | ZerogAnalyticsGeneralChartListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/network/transaction/tps',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTrxFeeAvg({
        requestBody,
    }: {
        requestBody: (HumanityAnalyticsTrxFeeRequest | KiteAnalyticsTrxFeeRequest),
    }): CancelablePromise<(HumanityAnalyticsGeneralChartListInfo | KiteAnalyticsGeneralChartListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/network/transaction/fee/avg',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTrxCount({
        requestBody,
    }: {
        requestBody: (NexonAnalyticsTrxCountRequest | HumanityAnalyticsTrxCountRequest | ZerogAnalyticsGeneralRequest),
    }): CancelablePromise<(NexonAnalyticsGeneralChartListInfo | HumanityAnalyticsGeneralChartListInfo | ZerogAnalyticsGeneralChartListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/network/transaction/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNetflow({
        requestBody,
    }: {
        requestBody: HumanityAnalyticsTrxCountRequest,
    }): CancelablePromise<HumanityAnalyticsNetflowChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/network/netflow',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBlockCreatedTimeAvg({
        requestBody,
    }: {
        requestBody: (HumanityAnalyticsBlockCreatedTimeRequest | KiteAnalyticsBlockCreatedTimeRequest | ZerogAnalyticsGeneralRequest),
    }): CancelablePromise<(HumanityAnalyticsGeneralChartListInfo | KiteAnalyticsGeneralChartListInfo | ZerogAnalyticsGeneralChartListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/network/block/created/time/avg',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBlockCount({
        requestBody,
    }: {
        requestBody: (HumanityAnalyticsBlockCountRequest | KiteAnalyticsBlockCountRequest | ZerogAnalyticsGeneralRequest),
    }): CancelablePromise<(HumanityAnalyticsGeneralChartListInfo | KiteAnalyticsGeneralChartListInfo | ZerogAnalyticsGeneralChartListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/network/block/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getMarketplaceTraders({
        requestBody,
    }: {
        requestBody: NexonAnalyticsUserRequest,
    }): CancelablePromise<NexonAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/marketplace/traders',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTotalSubnetCount({
        requestBody,
    }: {
        requestBody: KiteAnalyticsTotalSubnetCountRequest,
    }): CancelablePromise<KiteAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/kite/subnet/total/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTotalSubnetCallCount({
        requestBody,
    }: {
        requestBody: KiteAnalyticsTotalSubnetCallCountRequest,
    }): CancelablePromise<KiteAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/kite/subnet/call/total/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAgentCalledUawCount({
        requestBody,
    }: {
        requestBody: KiteAnalyticsUawCalledAgentsRequest,
    }): CancelablePromise<KiteAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/kite/agent/call/uaw',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTotalAgentCallCount({
        requestBody,
    }: {
        requestBody: KiteAnalyticsTotalAgentCallRequest,
    }): CancelablePromise<KiteAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/kite/agent/call/total/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getGeneralChartData({
        requestBody,
    }: {
        requestBody: AptosGeneralAnalyticsRequest,
    }): CancelablePromise<AptosAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/chart/general',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public downloadGeneralChartCsv({
        requestBody,
    }: {
        requestBody: AptosGeneralAnalyticsRequest,
    }): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/chart/general/csv',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getActiveUsers({
        requestBody,
    }: {
        requestBody: KiteAnalyticsRequest,
    }): CancelablePromise<KiteAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/active/users',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getExecuteTrxAccountCount({
        requestBody,
    }: {
        requestBody: ZerogAnalyticsGeneralRequest,
    }): CancelablePromise<ZerogAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/account/transaction/execution/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAverageAccountTrxCount({
        requestBody,
    }: {
        requestBody: ZerogAnalyticsGeneralRequest,
    }): CancelablePromise<ZerogAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/analytics/account/transaction/average/count',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
